import React, { useMemo } from 'react'

/**
 * エラーメッセージを表示するコンポーネント
 *
 * @param {{
 *   clientErrors: { [key: string]: string[] }
 *   fieldName: string
 * }} props
 */
export const ShowErrors = React.memo(({ clientErrors, fieldName }) => {
  const errorMessages = useMemo(() => clientErrors?.[fieldName], [clientErrors, fieldName])

  if (!errorMessages || errorMessages.length === 0) {
    return null
  }

  return (
    <>
      {errorMessages.map((err, index) => (
        <p key={index} className="red--text">
          {err}
        </p>
      ))}
    </>
  )
})

/**
 * サーバーエラーメッセージを表示するコンポーネント
 *
 * @param {{
 *   serverErrors: { [key: string]: string[] }
 * }} props
 */
export const ShowServerErrors = React.memo(({ serverErrors }) => {
  const errorMessages = useMemo(() => serverErrors?.messages, [serverErrors])

  if (!errorMessages || errorMessages.length === 0) {
    return null
  }

  return (
    <>
      {errorMessages.map((err, index) => (
        <p key={index} className="red--text">
          {err}
        </p>
      ))}
    </>
  )
})
